import { computed, ComputedRef } from '@vue/composition-api';
import { uniqBy } from 'lodash';

import { layoutStore } from './layouts';
import { LayoutFieldItem } from '../model/layout';
// import { expressionRelate } from '../model/field';

export const useFormulaFields = (
  fieldCollection: ComputedRef<LayoutFieldItem[]>,
  layoutStore: layoutStore
) => {
  // 已用字段中的公式字段集合
  const usedFormulaFields = computed<LayoutFieldItem[]>(
    () => (layoutStore.usedFields.value || []).filter(f => f.controlCode === 'formula')
  );
 
  // 已用公式字段所有依赖集合
  const usedExpressionIds = computed<number[]>(() => {
    const dependFields = (usedFormulaFields.value || [])
      .map(f => f.expressionRelateFieldList)
      .filter(Boolean)
      .flat();
    return uniqBy(dependFields, 'id').map(f => f.id);
  });
  const usedFormulaDepends = computed<LayoutFieldItem[]>(
    () => {
      // 这里从布局字段查找数据为防止用户修改布局名词后再移除字段
      return fieldCollection.value.filter(f => {
        const childFieldIds = f.childCustomFieldIds || f.childFields?.map(c => c.customFieldId) || [];
        return usedExpressionIds.value.some(
          id => [...childFieldIds, Number(f.customFieldId)].some(e => e === id)
        );
      });
    }
  );

  // 已使用的依赖字段
  const usedDependFields = computed<LayoutFieldItem[]>(
    () => (layoutStore.usedFields.value || [])
      .filter(item => usedFormulaDepends.value.some(f => f.fieldCode === item.fieldCode))
  );

  // 未加入布局的依赖
  const unusedDependFields = computed<LayoutFieldItem[]>(() => {
    const usedDependIds = usedDependFields.value.map(f => f.customFieldId);
    return (usedFormulaDepends.value || []).filter(f => !usedDependIds.includes(f.customFieldId));
  });

  // 是否已添加所有公式字段依赖
  const checkFormulaDepend = computed<boolean>(() => !(unusedDependFields.value?.length || lackOfDependency.value?.length));

  // 缺失依赖的字段
  const lackOfDependency = computed<LayoutFieldItem[]>(() => {
    // 未使用依赖的id集合
    const unusedDependIds = unusedDependFields.value.map(i => {
      const childFieldIds = i.childCustomFieldIds || i.childFields?.map(c => c.customFieldId) || [];
      return [i.customFieldId, ...childFieldIds];
    }).flat();

    return (usedFormulaFields.value || []).filter(field => {
      const dependFieldIds = (field.expressionRelateFieldList || []).map(f => f.id);
      return dependFieldIds.some(id => unusedDependIds.includes(id));
    });
  });
  
  return {
    usedFormulaFields,
    usedExpressionIds,
    usedFormulaDepends,
    usedDependFields,
    checkFormulaDepend,
    unusedDependFields,
    lackOfDependency
  };
};

export type FormulaFieldStore = ReturnType<typeof useFormulaFields>;